import { useState, useMemo } from 'react';
import { C } from '../../lib/tokens.js';
import { t } from '../../lib/data.js';
import { usePayments } from '../../lib/useBusinessData.js';
import { dateLong } from '../../lib/utils.js';
import { DocStatusChip } from '../../components/ui/Chips.jsx';
import { MoneyCell } from '../../components/ui/Misc.jsx';
import { PageShell } from '../../components/layout/PageShell.jsx';
import { matches, SearchInput, SimpleTable } from './shared.jsx';

export function PaymentsPage() {
  const [search, setSearch] = useState('');
  const { payments, loading } = usePayments();
  const filtered = useMemo(() => payments.filter(r => matches(search, r.ref, r.method)), [payments, search]);

  const cols = [
    { key: 'ref',    label: 'Reference', render: r => <span style={{ fontFamily: 'Roboto Mono', color: C.liquid, fontWeight: 500 }}>{r.ref}</span> },
    { key: 'date',   label: 'Date',      render: r => <span style={{ color: C.iron }}>{dateLong(r.date)}</span> },
    { key: 'method', label: 'Method' },
    { key: 'status', label: 'Status',    render: r => <DocStatusChip id={r.status} size="sm" /> },
    { key: 'amount', label: 'Amount', align: 'right', render: r => <MoneyCell amount={r.amount} currency="EUR" /> },
  ];
  return (
    <PageShell title={t('nav.payments')} subtitle="Payments received and allocated against your invoices."
      actions={<SearchInput value={search} onChange={setSearch} placeholder="Search reference, method…" />}>
      <SimpleTable columns={cols} rows={filtered} loading={loading} />
    </PageShell>
  );
}
